import { render } from "./SendRfp.vue?vue&type=template&id=70c2de08"
import script from "./SendRfp.vue?vue&type=script&lang=js"
export * from "./SendRfp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__